export function formatPKR(value) {
    if (value === null || typeof value === 'undefined') return '—';

    const n = typeof value === 'number' ? value : Number(String(value).replace(/,/g, '').trim());
    if (!Number.isFinite(n)) return '—';

    return `Rs. ${Math.round(n).toLocaleString('en-PK')}`;
}

export function formatNumberWithCommas(value) {
    if (value === null || typeof value === 'undefined') return '';
    const n = typeof value === 'number' ? value : Number(String(value).replace(/,/g, '').trim());
    if (!Number.isFinite(n)) return '';
    return Math.round(n).toLocaleString('en-PK');
}

